export default __webpack_public_path__ + "static/eugene-9dea0369f2e6d01c382f52ad81dbe35e.jpg";